/* eslint-disable no-unused-vars */
import styled, { css } from 'styled-components';
import { Palette } from 'config';

export const TableBox = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  gap: 16px;
  height: 100%;
`;

export const IconWrap = styled.div`
  height: 100%;
  flex-shrink: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 64px;
`;

// export const CheckboxWrap = styled.div`
//   height: 100%;
//   width: 100%;
//   display: flex;
//   justify-content: center;
//   padding-top: 24px;
//   border-right: 1px solid ${Palette.PrimaryGray._200};
// `;

export const TextBox = styled.div`
  width: 280px;
  max-width: 280px;
  flex-grow: 1;
  color: ${Palette.PrimaryGray._700};
  //padding-right: 16px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  overflow: hidden;
`;

export const DateParagraph = styled.p`
  display: flex;
  align-items: center;
  color: ${Palette.PrimaryGray._700};
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
`;

export const SubRowWrap = styled.div`
  display: flex;
  align-items: center;
  padding-left: 50px;
`;

export const SubRowText = styled.p`
  color: ${Palette.PrimaryGray._700};
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
  padding-right: 16px;
`;

export const FlexContainer = styled.div`
  margin-top: 4px;
  display: flex;
  align-items: center;
`;

export const Line = styled.div`
  position: absolute;
  top: 0;
  left: 28px;
  width: 1px;
  height: 100%;
  background-color: ${Palette.PrimaryGray._300};

  &:after {
    content: ' ';
    position: absolute;
    top: 50%;
    left: 0;
    width: 18px;
    height: 1px;
    background-color: ${Palette.PrimaryGray._300};
  }
`;

export const PlacementWrapper = styled.div`
  display: flex;
  align-items: center;
`;

export const TextWrapper = styled.div`
  padding-left: 45px;
  width: 100%;
  height: auto;
`;
